import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(isBetween);
dayjs.extend(duration);
dayjs.locale('vi');
dayjs.extend(customParseFormat);

export class DateUtils {
    public defaultDateFormat = 'DD/MM/YYYY';
    public defaultDatetimeFormat = 'hh:mm:ss A DD/MM/YYYY';
    public defaultTimeFormat = 'HH:mm:ss';
    public defaultIsoFormat = 'YYYY-MM-DDTHH:mm:sssZ';
    public defaultIsoFormatWithoutZ = 'YYYY-MM-DDTHH:mm:ss';
    public defaultDateIsoFormat = 'YYYY-MM-DD';
    public defaultTimeFormatWithoutSeconds = 'HH:mm A';
    public defaultDatetimeFormatWithoutSeconds = 'hh:mm A DD/MM/YYYY';

    public getDate(
        date: string | Date,
        format = this.defaultDateFormat
    ): string {
        const dt = this.getInstance(date);

        return dt.isValid() ? this.getDateTimeLocal(date, format) : '';
    }

    public getDateTime(
        date: string,
        outputFormat = this.defaultDatetimeFormat
    ): string {
        const dt = this.getInstance(date);

        return dt.isValid() ? dt.format(outputFormat) : '';
    }

    public getOperatingDays(date: string): number {
        return this.getInstance().diff(this.getInstance(date), 'hour');
    }

    public getCurrentDate(): string {
        return this.getInstance(new Date()).startOf('day').format();
    }

    public getRelativeTime(date: string): string {
        return this.getInstance(date).fromNow();
    }

    public convertToUTC = (localTime: string) => {
        return this.getInstance(localTime).utc().format();
    };

    public getInstance(date?: string | Date | null) {
        return date ? dayjs(date) : dayjs('');
    }

    public formatTime(date: string | Date, format = 'HH:mm'): string {
        return this.getInstance(date).format(format);
    }

    /**
     * Convert to local date time
     */
    public getDateTimeLocal(
        date: string | Date,
        outputFormat = this.defaultDatetimeFormat
    ): string {
        const dt = this.getInstance(date);

        return dt.isValid() ? dt.format(outputFormat) : '';
    }

    public toLocalDateTimeObject(date: string) {
        return dayjs.utc(date).tz('Asia/Ho_Chi_Minh');
    }

    public getCurrentYear() {
        return dayjs().year();
    }

    public getCurrentMonth() {
        return dayjs().month() + 1;
    }
}
